import { Component, OnInit, Input, Inject } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CoreService } from 'src/app/applicationModules/core/services/coreService/core.service';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MasterTemplateCategory } from '../Enum/common.enum';
import { StatusConstant } from '../status/status-constant';
import { LoaderService } from '../../shared/loader/loader.service';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-attachToTaskList',
  templateUrl: './attachToTaskList.component.html',
  styleUrls: ['./attachToTaskList.component.scss'] 
})

export class AttachToTaskListComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  formDialog: FormGroup; 
  spinner:boolean=false;
  OfficeIDList: any=[];
  myOfficeID: any;

  addTemplateForm: FormGroup;
  TaskIdForSingleTask:number=0;
  TaskTemplatesListForSingleTask:any=[]=[];
  TaskTemplatesListForSingleTaskFilter:any=[]=[];
  categoryTypeForSingleTask:number=0;
  taskTemplateIDForSingleTask:number=0;
  taskTemplateNameForSingleTask:string="";
  taskTitleForSingleTask:string="";
  selectedTemplate:any=[]=[];
  taskListIDforImportTask:number=0;
  taskListFolderID:number=0;

  rolesAsssign: any[] = [];
  isOrganizationAdmin: boolean = false;
  isSuperAdmin: boolean = false;

  addTaskListButton: boolean = false;
  TaskListName: string = "";
  taskCategoryList: any[] = [];
  filteredTaskCategoryList: any[] = [];
  selectedTaskCategoryID: number = 0;

  ShowNoRecordFoundTaskTemplates: Boolean = false;
  TaskTemplatesList: any = [] = [];
  FilteredTaskTemplatesList: any = [] = [];
  taskListIDforAddTemplate: number = 0;

  ShowNoRecordFound: boolean = false;
  updateTaskTemplateTasksButton: boolean = false;
  taslTemplateID: number = 0;
  showTaskListTemplate: boolean = true;
  showSingleTaskListTemplate: boolean = false;

  searchTemplateName: string = "";
  categoryType: number = 0;
  currentIndex: number = 0;
  timeout = null;

  AttachChecked:boolean=false;
  AssigneeChecked:boolean=false;
  NotifyChecked:boolean=false;

  constructor(public dialogRef: MatDialogRef<AttachToTaskListComponent>, private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, 
    private formBuilder: FormBuilder,private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    private statusConst: StatusConstant,private loaderService: LoaderService,
    private settingsService: SettingService,private sanitizer: DomSanitizer) {   
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);   
    this.currentUser = jwt_decode(token); 
    var offices = JSON.parse(sessionStorage.getItem('officeList') ?? '[]');
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)	
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      });
  }  
  
  ngOnInit(): void {
    this.rolesAsssign = JSON.parse(sessionStorage.getItem("roles"));
    if (this.rolesAsssign.length > 0) {
      this.isOrganizationAdmin = this.rolesAsssign.find(m => m.roleName == 'Organization Admin') != undefined;
      this.isSuperAdmin = this.rolesAsssign.find(m => m.roleName == 'Super Admin') != undefined;
    }
    this.categoryType=0;
    this.getActiveTaskTemplateCategories();
    this.getTaskTemplates();
  }  


   //======== =For TaskList Template==============//

   getActiveTaskTemplateCategories() {
    var ReqModel = {
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getActiveTaskTemplateCategories(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.taskCategoryList = response.data;
          this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == this.categoryType);
        }
        else {
          this.taskCategoryList = [];
          this.filteredTaskCategoryList = [];
        }
      }
      else {
        this.taskCategoryList = [];
        this.filteredTaskCategoryList = [];
      }
    });
   }

  getTaskTemplates() {
    this.ShowNoRecordFoundTaskTemplates = false;
    this.loaderService.show();
    this.filteredTaskCategoryList=[];
    this.FilteredTaskTemplatesList =[];
    var ReqModel = {
      folderID: this.selectedTaskCategoryID,
      searchKey: this.searchTemplateName,
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getTaskTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.TaskTemplatesList = response.data;
          // For My Template
          if(this.categoryType==0){
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 0);
           // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
            // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
           if(this.selectedTaskCategoryID==0){
            this.FilteredTaskTemplatesList = this.TaskTemplatesList;
           }else{
            this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => m.folderID == this.selectedTaskCategoryID);
           }           
          }
           // For Organization
          if(this.categoryType==1){
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 1);
            if(this.selectedTaskCategoryID==0){
              this.FilteredTaskTemplatesList = this.TaskTemplatesList;
             }else{
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => m.folderID == this.selectedTaskCategoryID);
             }   
           // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
           // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          }
           // For Global
          if(this.categoryType==2){
            this.filteredTaskCategoryList = this.taskCategoryList.filter(m => m.type == 2);
            if(this.selectedTaskCategoryID==0){
              this.FilteredTaskTemplatesList = this.TaskTemplatesList;
             }else{
              this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => m.folderID == this.selectedTaskCategoryID);
             }   
           // const taskTemplateCategoryIDs = this.filteredTaskCategoryList.map(m => m.taskTemplateCategoryID);
           // this.FilteredTaskTemplatesList = this.TaskTemplatesList.filter(m => taskTemplateCategoryIDs.indexOf(m.folderID) != -1);
          }
         
          if (this.FilteredTaskTemplatesList.length > 0) {
            this.ShowNoRecordFoundTaskTemplates = false;
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
          }         
        }
        else {
          this.ShowNoRecordFoundTaskTemplates = true;
          this.TaskTemplatesList = [];
          this.FilteredTaskTemplatesList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFoundTaskTemplates = true;
        this.TaskTemplatesList = [];
        this.FilteredTaskTemplatesList = [];
        this.loaderService.hide();
      }
    });
  }

  getTabDetails(event) {
    this.updateTaskTemplateTasksButton = false;
    this.taslTemplateID = 0;
    this.currentIndex=0;
    this.selectedTemplate=[];
    this.taskListTemplateID=0;

    if (event.tab.textLabel == "TaskList Template" || event.index == 0) {

      this.AttachChecked=false;
      this.AssigneeChecked=false;
      this.NotifyChecked=false;

      this.showTaskListTemplate = true;
      this.showSingleTaskListTemplate = false;
      this.categoryType=0;
      this.selectedTaskCategoryID=0;
      this.getActiveTaskTemplateCategories();
      this.getTaskTemplates();
    }

    if (event.tab.textLabel == "Single Task Template" || event.index == 1) {
      this.showTaskListTemplate = false;
      this.showSingleTaskListTemplate = true;
      this.selectedTaskCategoryID=0;
      this.categoryTypeForSingleTask=0;
      this.getTaskTemplatesForSingleTask();
    }
  }


  closeTemplate() {

    this.taskListTemplateID=0;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;

    this.taskListFolderID = 0;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.categoryType=0;
   // this.dialog.closeAll();
  }


  onTaskListTabChange($event) {

    this.taskListTemplateID=0;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;

    this.selectedTemplate=[];

    this.currentIndex=0;
    this.selectedTaskCategoryID = 0;    
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : textLabel == 'Organization' ? 2 : 1;
    this.categoryType = categoryValue;
    this.getTaskTemplates();   
  }


  getTaskListThroughCategory(e: any, i: any) {
    this.taskListTemplateID=0;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;

    this.currentIndex = i;
    this.selectedTaskCategoryID = e;
    this.getTaskTemplates();
  }

  searchTemplate(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {   

          this.taskListTemplateID=0;
          this.AttachChecked=false;
          this.AssigneeChecked=false;
          this.NotifyChecked=false;
          this.selectedTemplate=[];

          this.searchTemplateName = val;       
          this.FilteredTaskTemplatesList = this.FilteredTaskTemplatesList.filter(i => i.taskTemplateName.toLowerCase().indexOf(this.searchTemplateName.toLocaleLowerCase()) !== -1);
          //this.getTaskTemplates();
        }, 500);
      } else {

      }
    } else {
      this.searchTemplateName = "";
      this.getTaskTemplates();
    }
  }

  taskListTemplateID:number=0;

  async SelectTaskListTemplates(temp) {
    this.taskListTemplateID = temp.taskTemplateID;
    // this.data;
    // var modulename = Object.values(this.data)[0];
    
    // if(modulename=="Core"){
    //   this.TaskListTemplateImportCCC(Object.values(this.data)[1],temp,1);
    // }  
    // if(modulename=="Contact"){
    //   this.TaskListTemplateImportCCC(Object.values(this.data)[1],temp,2);
    // }
    // if(modulename=="Company"){
    //   this.TaskListTemplateImportCCC(Object.values(this.data)[1],temp,3);
    // }
  }

  async importTaskListTemplates() {
    this.data;
    var modulename = Object.values(this.data)[0];
    
    if(modulename=="Core"){
      this.TaskListTemplateImportCCC(Object.values(this.data)[1],1);
    }  
    if(modulename=="Contact"){
      this.TaskListTemplateImportCCC(Object.values(this.data)[1],2);
    }
    if(modulename=="Company"){
      this.TaskListTemplateImportCCC(Object.values(this.data)[1],3);
    }
  }


  async TaskListTemplateImportCCC(selectedRecords:any,cType){
    var cccIds:any=[];
    var attachDetailss:any=[];
    if (selectedRecords.length > 0) {     
      for (let i = 0; i < selectedRecords.length; i++) {      
        cccIds.push(selectedRecords[i].selectedRecord);
        var obj={
          "entityID": selectedRecords[i].selectedRecord,
          "cType": cType,
          "name": selectedRecords[i].name,
          "email": selectedRecords[i].email,
          "entityTypeID": selectedRecords[i].subFolderID,
        }
        attachDetailss.push(obj);
      }
    }
    this.loaderService.show();
    var ReqModel = {
      ciDs:cccIds,
      attachDetails:attachDetailss,
      cType: cType,  //1 Core,  2 Contact , 3 Company
      templateID: this.taskListTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: false,//this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    }
    //return;
    this.spinner = true;
    const result = await this.settingsService.addTaskListToCCCs(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide(); 
      this.taslTemplateID = 0;
      this.toastr.success("Task Imported successfully.", '', {
        timeOut: 3000,
      });
      this.dialogRef.close('Added');
      this.closeTemplate();
    }
    else {
      this.toastr.error("Task Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }


  //=========================================//




  ///========== For Single TaskList Template ==========//

  async importTaskTemplates() {
    this.data;
    var modulename = Object.values(this.data)[0];
    if(modulename=="Core"){
      this.SingleTaskListTemplateCore(Object.values(this.data)[1],1);
    } 
    if(modulename=="Contact"){
      this.SingleTaskListTemplateCore(Object.values(this.data)[1],2);
    } 
    if(modulename=="Company"){
      this.SingleTaskListTemplateCore(Object.values(this.data)[1],3);
    } 
  }

  async SingleTaskListTemplateCore(selectedRecords:any,cType){
    
    var cccIds:any=[];
    var attachDetailss:any=[]=[];
    if (selectedRecords.length > 0) {     
      for (let i = 0; i < selectedRecords.length; i++) {      
        cccIds.push(selectedRecords[i].selectedRecord);
        var obj={
          "entityID": selectedRecords[i].selectedRecord,
          "cType": cType,
          "name": selectedRecords[i].name,
          "email": selectedRecords[i].email,
          "entityTypeID": selectedRecords[i].subFolderID,
        }
        attachDetailss.push(obj);
      }
    }

    var taskIdss:any=[];
    if (this.selectedTemplate.length > 0) {     
      for (let i = 0; i < this.selectedTemplate.length; i++) {      
        taskIdss.push(this.selectedTemplate[i].taskId);
      }
    }
    
    this.loaderService.show();

    var ReqModel = {  
      ciDs:cccIds,
      attachDetails:attachDetailss,
      cType: cType,  //1 Core,  2 Contact , 3 Company  
      taskTemplateIDs:taskIdss,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      keepAttached: false,//this.AttachChecked,
      keepAssignee: this.AssigneeChecked,
      keepNotify: this.NotifyChecked,
    }
   //  return;
    this.spinner = true;
    const result = await this.settingsService.addTasksToCCCs(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner = false;
      this.loaderService.hide();     
      this.toastr.success("Task Imported successfully.", '', {
        timeOut: 3000,
      }); 

      this.dialogRef.close('Added');     
      this.closeImportTaskTemplate();
    }
    else {
      this.toastr.error("Task Import failed.", '', {
        timeOut: 3000,
      });
      this.spinner = false;
      this.loaderService.hide();
    }
  }
 
  closeImportTaskTemplate() {
    this.selectedTemplate=[];
    this.taskListFolderID = 0;
    this.taskListIDforImportTask=0;
    this.selectedTaskCategoryID = 0;
    this.searchTemplateName = "";
    this.categoryType=0;
   // this.dialog.closeAll();
  }

  onTaskListTabChangeForTaskImport($event) {
    
    this.taskListTemplateID=0;
    this.AttachChecked=false;
    this.AssigneeChecked=false;
    this.NotifyChecked=false;

    this.selectedTemplate=[];

    this.currentIndex=0;
    this.selectedTaskCategoryID = 0;
    const textLabel = $event.value;
    const categoryValue = textLabel == 'My Template' ? 0 : (textLabel == 'Organization' ? 2 : 1);  
    this.categoryTypeForSingleTask=categoryValue;
    this.getTaskTemplatesForSingleTask();   
  }


  getTaskTemplatesForSingleTask() {
    this.ShowNoRecordFoundTaskTemplates = false;
    this.loaderService.show();
    var ReqModel = {
      categoryID: Number(this.selectedTaskCategoryID),
      templateType: Number(this.categoryTypeForSingleTask),
      userID: this.currentUser.UID,
      officeID: Number(this.myOfficeID),
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getSingleTaskTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data != null) {
          this.TaskTemplatesListForSingleTask = response.data.tasks;
          this.TaskTemplatesListForSingleTaskFilter= response.data.tasks;         
          if (this.TaskTemplatesListForSingleTask.length > 0) {
            this.ShowNoRecordFoundTaskTemplates = false;
          } else {
            this.ShowNoRecordFoundTaskTemplates = true;
          }         
        }
        else {
          this.ShowNoRecordFoundTaskTemplates = true;
          this.TaskTemplatesListForSingleTask = [];
          this.loaderService.hide();
        }
      }
      else {
        this.TaskTemplatesListForSingleTask = [];
        this.ShowNoRecordFound = true;
        this.loaderService.hide();
      }
    });
  }

 
  getTaskListThroughCategoryForTaskImport(e: any, i: any) {
    this.selectedTemplate=[];
    this.currentIndex = i
    this.selectedTaskCategoryID = e;
    this.getTaskTemplatesForSingleTask();  
  }

  searchTemplateForSingleTask(val) {
    if (val.length >= 2) {
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {        
        this.TaskTemplatesListForSingleTask = this.TaskTemplatesListForSingleTaskFilter.filter(i => i.templateName.toLowerCase().indexOf(val.toLocaleLowerCase()) !== -1);
        }, 500);
      } else {

      }
    } else {
      this.searchTemplateName = "";  
      this.getTaskTemplatesForSingleTask();    
    }
  }

    //Checkbox Change detecting function
    getCheckboxValues(event, template) { 
      if (event.checked) {     
        this.selectedTemplate.push(template);     
      } else {
        let removeIndex = this.selectedTemplate.findIndex((itm) => itm === template);
        if (removeIndex !== -1) this.selectedTemplate.splice(removeIndex, 1);    
      }
      if(this.selectedTemplate.length == 0) {       
      }
     }

     closeAll(){
      this.AttachChecked=false;
      this.AssigneeChecked=false;
      this.NotifyChecked=false;

      this.currentIndex=0;
      this.dialog.closeAll();
      this.closeTemplate();
      this.closeImportTaskTemplate();
     }

     showOptions(event:MatCheckboxChange,data): void {
      if(data=="Attach"){
       this.AttachChecked=event.checked;
      }
      if(data=="Assignee"){
        this.AssigneeChecked=event.checked;
      }
      if(data=="Notify"){
        this.NotifyChecked=event.checked;
      }
    }
}

